import type { Theme, SxProps } from '@mui/material/styles';

import { useTabs } from 'minimal-shared/hooks';
import { varAlpha } from 'minimal-shared/utils';
import { useRef, useState, useEffect } from 'react';

import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Grid from '@mui/material/Grid2';
import Button from '@mui/material/Button';
import { Box, Divider } from '@mui/material';
import Container from '@mui/material/Container';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';

import { userForOrganizerFunc } from 'src/context/user/userForOrganizer';

import { Iconify } from 'src/components/iconify';
import { EmptyContent } from 'src/components/empty-content';

import { ProductDetailsSkeleton } from '../product-skeleton';
import { ProductDetailsReview } from '../product-details-review';
import { ProductDetailsSummary } from '../product-details-summary';
import { ProductDetailsCarousel } from '../product-details-carousel';
import { ProductExteriorOrganizer } from '../product-exterior-organizer';
import { ProductDetailsDescription } from '../product-details-description';
import { ProductSocialInfoForBlog } from '../product-social-info-for-blog';

// ----------------------------------------------------------------------

type Props = {
  product?: any;
  loading?: boolean;
  error?: any | undefined;
  data: any;
  entityType: string;
};

export function ProductShopDetailsView({ product, error, loading, data, entityType }: Props) {
  console.log(product, 'product');
  const accessTokenJSON = localStorage.getItem('auth') as string;
  const accessToken = JSON.parse(accessTokenJSON)?.accessToken ?? null;
  const containerStyles: SxProps<Theme> = {
    mt: 5,
    mb: 10,
  };

  const tabs = useTabs('description');
  const reviewsTargetRef = useRef<HTMLDivElement>(null);

  if (loading) {
    return (
      <Container sx={containerStyles}>
        <ProductDetailsSkeleton />
      </Container>
    );
  }

  if (error) {
    return (
      <Container sx={containerStyles}>
        <EmptyContent
          filled
          title="Product not found!"
          action={
            <Button
              component={RouterLink}
              href={paths.aktivite.root}
              startIcon={<Iconify width={16} icon="eva:arrow-ios-back-fill" />}
              sx={{ mt: 3 }}
            >
              Back to list
            </Button>
          }
          sx={{ py: 10 }}
        />
      </Container>
    );
  }

  return (
    <Container sx={containerStyles}>
      <Grid container spacing={{ xs: 3, md: 5 }}>
        <Grid size={{ xs: 12, md: 6 }}>
          <ProductDetailsCarousel
            images={
              product?.listing?.images && product?.listing?.images.length > 0
                ? [product?.listing?.coverImage].concat(product?.listing?.images)
                : [product?.listing?.coverImage]
            }
            product={product}
          />
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          {product && (
            <ProductDetailsSummary
              product={product}
              data={data}
              entityType={entityType}
              setReviewTabActive={() => {
                tabs.setValue('reviews');

                if (reviewsTargetRef.current) {
                  setTimeout(() => {
                    reviewsTargetRef.current?.scrollIntoView({
                      behavior: 'smooth',
                      block: 'center',
                    });
                  }, 100);
                }
              }}
            />
          )}
        </Grid>
      </Grid>

      {/* <Tabs
        ref={reviewsTargetRef}
        value={tabs.value}
        onChange={tabs.onChange}
        TabIndicatorProps={{
          style: {
            backgroundColor: '#7DC9CF',
            height: '6px',
            borderRadius: 1,
          },
        }}
        sx={[
          (theme) => ({
            px: 3,
            mt: 3,
            boxShadow: `inset 0 -2px 0 0 ${varAlpha(theme.vars.palette.grey['500Channel'], 0.08)}`,
          }),
        ]}
      >
        {[
          { value: 'description', label: 'Etkinlik Detayları' },
          { value: 'reviews', label: `Yorumlar (${product?.listing?.reviews.count})` },
          { value: 'exteriorOrganizer', label: 'Organizatör' },
        ].map((tab) => (
          <Tab key={tab.value} value={tab.value} label={tab.label} />
        ))}
      </Tabs>

      {tabs.value === 'description' && <ProductDetailsDescription product={product} />}

      {tabs.value === 'reviews' && (
        <ProductDetailsReview
          ratings={product?.ratings || []}
          reviews={product?.listing?.reviews.data}
          totalRatings={product?.totalRatings || 0}
          totalReviews={product?.listing?.reviews.count}
          listingId={product?.listing?._id}
          activityId={product?._id}
        />
      )}

      {tabs.value === 'exteriorOrganizer' && (
        <ProductExteriorOrganizer product={product} data={data} />
      )} */}

      <Divider sx={{ borderStyle: 'dashed', pt: 4 }} />

      <ProductDetailsDescription product={product} entityType={entityType} />

      <Divider sx={{ borderStyle: 'dashed' }} />

      {entityType === 'aktivite' && <ProductExteriorOrganizer product={product} data={data} />}
      {entityType === 'blog' && <ProductSocialInfoForBlog product={product} data={data} />}

      <Divider sx={{ borderStyle: 'dashed' }} />
      <Box ref={reviewsTargetRef} />

      <ProductDetailsReview
        ratings={product?.ratings || []}
        reviews={product?.listing?.reviews.data}
        totalRatings={product?.totalRatings || 0}
        totalReviews={product?.listing?.reviews.count}
        listingId={product?.listing?._id}
        activityId={product?._id}
        entityType={entityType}
      />
    </Container>
  );
}
